"use strict";

/* ============================================================
   ABR rental product — Rent / Buy / Custom + look builder
   Variants: option1 = Mode ("Rent"|"Buy"), option2 = Size.
   Size modal mirrors the store's Proper-Cloth-style picker:
   Jacket Size + Fit + Length + optional Pants waist/inseam,
   captured as order properties (work-ticket for the tailors).
   ============================================================ */
(function () {
  var dataEl = document.getElementById("rp-variant-data");
  if (!dataEl) return;

  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var state = { mode: "Rent", size: null, variantId: null };
  var selCut = "Classic", selLen = "Regular", selWaist = null, selInseam = null;

  var priceEl = document.getElementById("rp-price");
  var addBtn = document.getElementById("rp-add");
  var customCta = document.getElementById("rp-custom-cta");
  var dateWrap = document.getElementById("rp-date-wrap");
  var modeNote = document.getElementById("rp-note");
  var modal = document.getElementById("size-modal");
  var grid = modal.querySelector(".sz-grid");
  var note = modal.querySelector(".sz-custom-note");
  var szAdd = document.getElementById("sz-add");
  var szPrice = document.getElementById("sz-price");
  var form = document.getElementById("rp-form");

  var SIZE_LABELS = { "32": "XXS", "34": "XS", "36": "S", "38": "M", "40": "M/L", "42": "L", "44": "XL", "46": "XXL", "48": "3XL", "50": "4XL" };
  var FITS = [
    { id: "Slim", note: "" },
    { id: "Classic", note: "Most Popular" },
    { id: "Athletic", note: "" }
  ];
  /* Kept identical to product.js — continuous, no overlaps, open at both ends. */
  var LENGTHS = [
    { id: "Short", note: "Under 5′9″" },
    { id: "Regular", note: "5′9″–5′10″" },
    { id: "Tall", note: "5′11″–6′0″" },
    { id: "Very Tall", note: "6′1″ and up" }
  ];
  var WAISTS = [
    ["28","XS"],["29","XS"],["30","S"],["31","S"],["32","M"],["33","M"],
    ["34","L"],["35","L"],["36","XL"],["38","2XL"],["40","3XL"],["42","4XL"]
  ];
  var INSEAMS = [
    ["27","Under 5′6″"],["28","5′6″–5′7″"],
    ["29","5′8″–5′9″"],["30","5′10″–5′11″"],
    ["31","6′0″"],["32","6′1″–6′2″"],
    ["33","6′3″"],["34","6′4″ and up"]
  ];

  /* Custom price is per-product (metafield abr.custom_price), rendered into the
     mode strip by the template. Falls back to the house minimum. */
  var CUSTOM_PRICE = (document.getElementById("mode-seg") || {}).dataset
    ? document.getElementById("mode-seg").dataset.customPrice || "$495+"
    : "$495+";

  /* Set by the template from the product title/type, with tag overrides. */
  var jacketOnly = modal.dataset.jacketOnly === "true";

  var MODE_NOTES = {
    Rent: "Damage waiver included · Fitted before your event · Easy Monday returns",
    Buy: "Free fitting included · Two months of free size adjustments · Yours to keep",
    Custom: "Made to your measurements · Your fabric, your lining, your initials · From " + CUSTOM_PRICE
  };

  function byMode(mode) {
    return variants.filter(function (v) { return String(v.mode).toLowerCase() === mode.toLowerCase(); });
  }

  function minPrice(mode) {
    var vs = byMode(mode);
    if (!vs.length) return null;
    var min = vs.reduce(function (a, v) { return v.cents < a.cents ? v : a; });
    return min.price;
  }

  /* Mode price labels */
  var rentLabel = document.getElementById("mode-price-rent");
  var buyLabel = document.getElementById("mode-price-buy");
  if (rentLabel) rentLabel.textContent = minPrice("Rent") || "—";
  if (buyLabel) buyLabel.textContent = minPrice("Buy") || "—";

  function sizeNum(size) {
    var m = String(size).trim().match(/^(\d{2})/);
    return m ? m[1] : String(size);
  }

  function buildGrid() {
    grid.classList.add("szp");
    var vs = byMode(state.mode).slice().sort(function (a, b) { return sizeNum(a.size) - sizeNum(b.size); });
    var html = '<h3 class="szp-label">Jacket Size</h3><div class="szp-row cols-3" data-group="size">';
    vs.forEach(function (v) {
      var num = sizeNum(v.size);
      if (v.available) {
        html += '<div class="szp-cell"><button type="button" class="size-btn" data-id="' + v.id + '" data-price="' + v.price + '" data-label="' + num + '">' + num + '</button><small>' + (SIZE_LABELS[num] || "&nbsp;") + '</small></div>';
      } else {
        html += '<div class="szp-cell"><button type="button" class="size-btn soldout" data-custom="1">' + num + '<small>Custom made</small></button><small>' + (SIZE_LABELS[num] || "&nbsp;") + '</small></div>';
      }
    });
    html += '</div>';

    html += '<h3 class="szp-label">Fit</h3><div class="szp-row cols-3" data-group="fit">';
    FITS.forEach(function (f) {
      html += '<div class="szp-cell"><button type="button" class="size-btn' + (f.id === selCut ? " selected" : "") + '" data-cut="' + f.id + '">' + f.id + '</button><small>' + (f.note || "&nbsp;") + '</small></div>';
    });
    html += '</div>';

    html += '<h3 class="szp-label">Length</h3><div class="szp-row cols-4" data-group="length">';
    LENGTHS.forEach(function (l) {
      html += '<div class="szp-cell"><button type="button" class="size-btn' + (l.id === selLen ? " selected" : "") + '" data-len="' + l.id + '">' + l.id + '</button><small>' + l.note + '</small></div>';
    });
    html += '</div>';

    /* A jacket or blazer on its own has no trousers to size. */
    if (!jacketOnly) {
      html += '<h3 class="szp-label">Pants — Waist <span class="szp-opt">Optional · fitted free</span></h3><div class="szp-row cols-4" data-group="waist">';
      WAISTS.forEach(function (w) {
        html += '<div class="szp-cell"><button type="button" class="size-btn' + (w[0] === selWaist ? " selected" : "") + '" data-waist="' + w[0] + '">' + w[0] + '</button><small>' + w[1] + '</small></div>';
      });
      html += '</div>';

      /* Inseam row removed for now (kept INSEAMS + handlers for easy restore). */
    }

    grid.innerHTML = html;
    szPrice.textContent = minPrice(state.mode) || "—";
    updateConfirm();
  }

  function summary() {
    var parts = [state.size];
    if (selCut !== "Classic") parts.push(selCut);
    if (selLen !== "Regular") parts.push(selLen);
    return parts.filter(Boolean).join(" · ");
  }

  function updateConfirm() {
    szAdd.disabled = !state.variantId;
    szAdd.textContent = state.variantId ? "Confirm " + summary() : "Confirm Size";
  }

  function setMode(mode) {
    state.mode = mode;
    state.size = null;
    state.variantId = null;
    document.querySelectorAll(".mode-btn").forEach(function (b) { b.classList.toggle("active", b.dataset.mode === mode); });
    document.getElementById("rp-prop-mode").value = mode;
    if (modeNote) modeNote.textContent = MODE_NOTES[mode] || "";

    var isCustom = mode === "Custom";
    customCta.classList.toggle("hidden", !isCustom);
    addBtn.classList.toggle("hidden", isCustom);
    document.querySelector("[data-open-size]").classList.toggle("hidden", isCustom);
    dateWrap.style.display = mode === "Rent" ? "" : "none";

    if (!isCustom) {
      priceEl.textContent = minPrice(mode) || "—";
      addBtn.disabled = true;
      addBtn.textContent = "Add to Bag";
      var openBtn = document.querySelector("[data-open-size]");
      if (openBtn) openBtn.textContent = "Select Size";
      buildGrid();
    } else {
      priceEl.textContent = CUSTOM_PRICE;
    }
  }

  /* Mode toggle */
  document.getElementById("mode-seg").addEventListener("click", function (e) {
    var btn = e.target.closest(".mode-btn");
    if (btn) setMode(btn.dataset.mode);
  });

  /* Size modal open/close */
  function open() { modal.classList.add("open"); document.body.style.overflow = "hidden"; }
  function close() { modal.classList.remove("open"); document.body.style.overflow = ""; }
  document.querySelectorAll("[data-open-size]").forEach(function (b) { b.addEventListener("click", open); });
  modal.querySelector(".sz-backdrop").addEventListener("click", close);
  modal.querySelector(".sz-close").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  /* Picker clicks */
  grid.addEventListener("click", function (e) {
    var btn = e.target.closest(".size-btn");
    if (!btn) return;

    if (btn.dataset.custom) {
      note.classList.add("show");
      note.innerHTML = 'That size is out of stock — but the Atelier will make it <strong>to your exact measurements</strong> from ' + CUSTOM_PRICE + '. <a href="/pages/made-to-measure">Have it custom made →</a>';
      return;
    }
    note.classList.remove("show");

    var row = btn.closest(".szp-row");
    var group = row ? row.dataset.group : "";
    var wasSelected = btn.classList.contains("selected");
    if (row) row.querySelectorAll(".size-btn.selected").forEach(function (x) { x.classList.remove("selected"); });

    if (group === "size") {
      btn.classList.add("selected");
      state.variantId = btn.dataset.id;
      state.size = btn.dataset.label;
      szPrice.textContent = btn.dataset.price;
    } else if (group === "fit") { btn.classList.add("selected"); selCut = btn.dataset.cut; }
    else if (group === "length") { btn.classList.add("selected"); selLen = btn.dataset.len; }
    else if (group === "waist") { selWaist = wasSelected ? null : btn.dataset.waist; if (!wasSelected) btn.classList.add("selected"); }
    else if (group === "inseam") { selInseam = wasSelected ? null : btn.dataset.inseam; if (!wasSelected) btn.classList.add("selected"); }

    updateConfirm();
  });

  function setProp(name, value) {
    var input = form.querySelector('input[name="properties[' + name + ']"][data-dyn]');
    if (!input && value) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[" + name + "]";
      input.setAttribute("data-dyn", "1");
      form.appendChild(input);
    }
    if (input) {
      if (value) input.value = value;
      else input.remove();
    }
  }

  szAdd.addEventListener("click", function () {
    if (!state.variantId) return;
    close();
    var sel = grid.querySelector('.szp-row[data-group="size"] .size-btn.selected');
    if (sel) priceEl.textContent = sel.dataset.price;

    setProp("Cut", selCut + " fit");
    setProp("Length", selLen !== "Regular" ? selLen + " — altered to fit, free" : null);
    setProp("Pants waist", selWaist ? selWaist + "″ — hemmed free by ABR" : null);
    setProp("Pants inseam", selInseam ? selInseam + "″ — hemmed free by ABR" : null);

    var openBtn = document.querySelector("[data-open-size]");
    openBtn.textContent = "Size: " + summary();
    addBtn.disabled = false;
    addBtn.textContent = state.mode === "Rent" ? "Add Rental to Bag" : "Add to Bag";
  });

  /* Look builder chips → hidden props */
  document.querySelectorAll(".look-group").forEach(function (group) {
    group.addEventListener("click", function (e) {
      var chip = e.target.closest(".look-chip");
      if (!chip) return;
      group.querySelectorAll(".look-chip.active").forEach(function (c) { c.classList.remove("active"); });
      chip.classList.add("active");
      var input = document.getElementById("rp-prop-" + group.dataset.prop);
      if (input) input.value = chip.dataset.value;
    });
  });
  // initialize defaults
  document.querySelectorAll(".look-group").forEach(function (group) {
    var active = group.querySelector(".look-chip.active");
    var input = document.getElementById("rp-prop-" + group.dataset.prop);
    if (active && input) input.value = active.dataset.value;
  });

  /* Event date */
  var dateInput = document.getElementById("rp-date");
  if (dateInput) {
    dateInput.addEventListener("change", function () {
      document.getElementById("rp-prop-date").value = dateInput.value;
    });
  }

  /* Add to bag */
  addBtn.addEventListener("click", function () {
    if (!state.variantId) { open(); return; }
    if (state.mode === "Rent" && dateInput && !dateInput.value) {
      dateInput.focus();
      dateInput.style.borderColor = "#b14e24";
      return;
    }
    document.getElementById("rp-variant-id").value = state.variantId;
    if (form.getAttribute("data-demo") !== null) {
      addBtn.textContent = "Added ✓";
      return;
    }
    form.submit();
  });

  setMode("Rent");
})();
